import omit from "lodash/omit";

export const subscribeGetRestaurantList = (callback) => {
  const restaurantRef = window.firebaseRef(window.firebaseDB, "restaurants");

  // Subscribe to real-time updates
  return window.firebaseOnValue(restaurantRef, callback);
};

export const createOrUpdateRestaurant = async (formValues, callback) => {
  try {
    const restaurantRef = window.firebaseRef(window.firebaseDB, "restaurants");
    if (formValues?.id) {
      // Update restaurant
      await window.firebaseUpdate(restaurantRef, {
        [formValues?.id]: omit(formValues, "id"),
      });
    } else {
      // Create new restaurant
      const newRef = window.firebasePush(restaurantRef);
      await window.firebaseSet(newRef, formValues);
    }
  } catch (err) {
    callback?.(err);
  }
};

export const deleteRestaurant = async (id, callback) => {
  try {
    const restaurantItemRef = window.firebaseRef(
      window.firebaseDB,
      `restaurants/${id}`
    );

    await window.firebaseRemove(restaurantItemRef);
  } catch (err) {
    callback?.(err);
  }
};

export const addComment = async (formValues, callback) => {
  try {
    const commentRef = window.firebaseRef(
      window.firebaseDB,
      `restaurants/${formValues?.id}/comments`
    );
    window.firebasePush(commentRef, {
      text: formValues?.text,
      rating: formValues?.rating,
      createTime: Date.now(),
    });
  } catch (err) {
    callback?.(err);
  }
};
